import { ArrowUpRight, Github, Linkedin, Mail, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/site";
import { MaskLines, Reveal, SectionLabel } from "@/components/Primitives";
import { ContactForm } from "@/components/ContactForm";

export const CHANNELS = [
  { id: "email", label: "Email", value: CONTACT.email, href: CONTACT.email && `mailto:${CONTACT.email}`, Icon: Mail },
  { id: "github", label: "GitHub", value: CONTACT.github.replace(/^https?:\/\//, ""), href: CONTACT.github, Icon: Github },
  { id: "discord", label: "Discord", value: CONTACT.discord.replace(/^https?:\/\//, ""), href: CONTACT.discord, Icon: MessageCircle },
  { id: "linkedin", label: "LinkedIn", value: CONTACT.linkedin.replace(/^https?:\/\//, ""), href: CONTACT.linkedin, Icon: Linkedin },
].filter((c) => c.href);

export const Contact = () => (
  <section id="contact" className="border-t border-line py-28 sm:py-36 lg:py-44" data-testid="contact-section">
    <div className="container-x grid grid-cols-1 gap-20 lg:grid-cols-12 lg:gap-10">
      <div className="lg:col-span-6">
        <SectionLabel index="05" label="Let's Connect" />
        <MaskLines lines={["Have Something", "In Mind?"]} className="mt-8 font-serif text-5xl font-light leading-[1] text-ivory sm:text-6xl lg:text-7xl" />
        <Reveal as="p" className="mt-8 max-w-md text-base leading-relaxed text-ash sm:text-lg">
          Whether it's a website, a software idea, or an interesting collaboration, let's build something worth remembering.
        </Reveal>
        <ul className="mt-14 border-t border-line">
          {CHANNELS.map(({ id, label, value, href, Icon }, i) => (
            <Reveal as="li" key={id} delay={i * 0.06}>
              <a
                href={href}
                target={id === "email" ? undefined : "_blank"}
                rel="noopener noreferrer"
                className="group flex items-center gap-5 border-b border-line py-5 transition-colors duration-300 hover:text-ivory"
                data-testid={`contact-link-${id}`}
              >
                <Icon size={18} strokeWidth={1.25} className="text-gold" />
                <span className="w-24 font-mono text-xs uppercase tracking-[0.2em] text-ash">{label}</span>
                <span className="flex-1 truncate text-ivory/90">{value}</span>
                <ArrowUpRight size={18} className="text-ash transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-gold" />
              </a>
            </Reveal>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-5 lg:col-start-8">
        <ContactForm />
      </div>
    </div>
  </section>
);
